import React, { FC, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeProps } from './theme.types';
import GlobalStyles from './GlobalStyles';
import themeDef from './themeDef';

const Theme : FC<ThemeProps> = ({
  children,
  theme,
  customStyles,
}: ThemeProps) => {

  const { defaultTheme } = themeDef;

  const mergedTheme = useMemo(() => {
    return {
      ...defaultTheme,
      ...theme
    };
  }, [defaultTheme, theme]);

  return (
    <ThemeProvider theme={mergedTheme}>
      <GlobalStyles 
        customStyles={customStyles} 
      />
      {children}
    </ThemeProvider>
  );

};

export default Theme;